import { CheqLoader } from '@clickcease/cc-client-components-lib'
import { SplitFactory, SplitSdk } from '@splitsoftware/splitio-react'
import React, { useMemo } from 'react'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const SplitProvider = ({ children }) => {
  const { accountId } = useUserStore()

  const urlParams = new URLSearchParams(window.location.search)
  let segmentName = ''

  // check if page is signup and if force split was passed in the url
  if (window.location.href.includes('signup') && urlParams.has('forcesplit')) {
    segmentName = urlParams.get('forcesplit') || ''
  }

  //generate temp uuid in case user is not identified for example sign up or login pages
  const generateEntranceId = (): string => {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c: string) => {
      const randomByte = crypto.getRandomValues(new Uint8Array(1))[0]
      const nibble = c === '0' ? randomByte & 0x0f : (randomByte & 0xf0) >> 4
      return nibble.toString(16)
    })
  }
  const createSDK = (key: string) => {
    return SplitSdk({
      core: {
        authorizationKey: process.env.REACT_APP_SPLIT_KEY || '',
        key: key,
      },
      scheduler: {
        eventsPushRate: 5,
        impressionsRefreshRate: 5,
        metricsRefreshRate: 5,
      },
      streamingEnabled: true,
      debug: false,
    })
  }

  // check if key already exists in local storage, if force was passed in the url and set local storage to the value in the url
  // if no account id(not logged) generate random number which will remain in local storage unless user sign up or login and that will turn into an account id
  const splitKey = useMemo(() => {
    const storedKey = localStorage.getItem('splitKey') || ''

    if (segmentName) {
      localStorage.setItem('splitKey', segmentName)
    } else if (!accountId && !storedKey) {
      const generatedKey = generateEntranceId()
      localStorage.setItem('splitKey', generatedKey)
      return generatedKey
    }
    const storageKey = localStorage.getItem('splitKey') || ''
    return storageKey !== accountId.toString() && /^\D+$/.test(storageKey)
      ? localStorage.getItem('splitKey') || ''
      : !accountId
      ? storedKey
      : accountId.toString()
  }, [accountId, segmentName])

  const config = useMemo(() => createSDK(splitKey), [splitKey])

  return config ? (
    <SplitFactory factory={config} updateOnSdkUpdate={true}>
      {children}
    </SplitFactory>
  ) : (
    <CheqLoader />
  )
}
